module.exports = __webpack_public_path__ + "static/media/ic_presenter.fcf77f7e.svg";